import React, { Component } from "react";
import _ from "lodash";

export interface BulletsSelectItem {
    value: string | number;
    label: string;
    appendex?: any;
}

export interface BulletsSelectProps {
    field?: any;
    form?: any;
    items?: { label: any; value: any; appendex?: any }[];
    givenid?: string;
    enableSearch?: boolean;
    completeList?: { label: any; value: any; appendex?: any }[];
    orderByLabel?: boolean;
    exclusive?: boolean;
    disabled?: boolean;
}

export interface BulletsSelectState {
    items: {
        label: string;
        value: string;
        selected: boolean;
        appendex?: any;
    }[];
    searchText: string;
}

function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

const formatSearchText = (text, value) => {
    // Split on higlight term and include term into parts, ignore case
    let parts = text.split(new RegExp(`(${escapeRegExp(value)})`, "gi"));
    return (
        <span>
            {parts.map((part, i) => {
                if (part.toUpperCase() == value.toUpperCase())
                    return (
                        <span className="highlighted" key={i}>
                            {part}
                        </span>
                    );
                else return part;
            })}
        </span>
    );
};

export default class BaseBulletsSelect extends Component<
    BulletsSelectProps,
    BulletsSelectState
> {
    searchBox: React.RefObject<HTMLInputElement>;

    constructor(props: BulletsSelectProps) {
        super(props);

        this.searchBox = React.createRef();

        let initialItems = [];
        if (props.field.value === undefined || props.field.value.length === 0) {
            initialItems = props.items.map(item => ({
                value: item.value,
                label: item.label,
                appendex: item.appendex,
                selected: false
            }));
        } else {
            const chosenIds = Array.isArray(props.field.value)
                ? props.field.value
                : [props.field.value];
            const initialItemIds = props.items
                .filter(item => !chosenIds.includes(item.value))
                .map(item => item.value);

            let dataSource = props.completeList
                .map(item => {
                    return {
                        value: item.value,
                        label: item.label,
                        appendex: item.appendex,
                        selected: chosenIds.includes(item.value)
                    };
                })
                .filter(
                    item =>
                        chosenIds.includes(item.value) ||
                        initialItemIds.includes(item.value)
                );

            initialItems = dataSource;
        }

        this.state = {
            items: initialItems,
            searchText: ""
        };
    }

    onChangeHandler = () => {
        let value = this.state.items
            .filter(item => item.selected)
            .map(item => item.value);

        this.props.form.setFieldValue(this.props.field.name, value);
    };

    onSelectItem = selectedItem => {
        if (this.props.disabled) return;

        let newItemState = [];

        newItemState = this.state.items.map(item => {
            item.selected =
                item.value === selectedItem.value
                    ? !item.selected
                    : item.selected;

            if (this.props.exclusive && item.value != selectedItem.value) {
                item.selected = false;
            }

            return item;
        });

        this.setState(
            {
                ...this.state,
                items: newItemState
            },
            () => this.onChangeHandler()
        );
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.disabled == true) {
            const chosenIds = Array.isArray(nextProps.field.value)
                ? nextProps.field.value
                : [nextProps.field.value];
            const initialItemIds = nextProps.items
                .filter(item => !chosenIds.includes(item.value))
                .map(item => item.value);

            let dataSource = nextProps.completeList
                .map(item => {
                    return {
                        value: item.value,
                        label: item.label,
                        appendex: item.appendex,
                        selected: chosenIds.includes(item.value)
                    };
                })
                .filter(
                    item =>
                        chosenIds.includes(item.value) ||
                        initialItemIds.includes(item.value)
                );

            return {
                ...prevState,
                items: dataSource
            };
        }
        return prevState;
    }

    setSearch = e => {
        this.setState({
            searchText: e.target.value
        });
    };

    cleanSearch = () => {
        this.setState({
            searchText: ""
        });
        this.searchBox.current.value = "";
    };

    render() {
        const items = this.props.orderByLabel
            ? _.orderBy(this.state.items, ["label"], ["asc"])
            : this.state.items;

        const fieldName = this.props.field.name;
        const errors = this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        return (
            <div
                id={this.props.givenid + " Bullets-Select"}
                className={`bullets-select ${
                    this.props.disabled ? "disabled" : ""
                }`}
            >
                <div className="input-group">
                    {this.props.enableSearch && (
                        <div
                            className={`bullet-search ${
                                this.state.searchText.length ? "searching" : ""
                            }`}
                        >
                            <input
                                placeholder="Search"
                                type="text"
                                ref={this.searchBox}
                                onChange={this.setSearch}
                            />
                            <button
                                className="clean"
                                onClick={this.cleanSearch}
                            >
                                <i className="icon-times-solid"></i>
                            </button>
                        </div>
                    )}
                    {items.length == 0 &&
                        this.props.completeList.length > 0 && (
                            <p>No more items left to choose.</p>
                        )}
                    {items.length == 0 &&
                        this.props.completeList.length == 0 && (
                            <p>No items available to choose from.</p>
                        )}
                    {items.map(item => {
                        const label =
                            this.state.searchText !== null &&
                            this.state.searchText.length > 2
                                ? formatSearchText(
                                      item.label,
                                      this.state.searchText
                                  )
                                : item.label;
                        return (
                            <div
                                key={item.value}
                                onClick={() => this.onSelectItem(item)}
                                className={`bullet ${
                                    item.selected ? "selected" : ""
                                } ${item.appendex ? item.appendex : ""}`}
                            >
                                {label}
                            </div>
                        );
                    })}
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
